<template>
  <div>
    <div class="menuOpciones_tabs d-flex justify-content-center" style="background: white;">
        <ul class="d-flex scroll-contenedor">
            <li class="opc">
                <router-link :to="{name: 'SHacienda'}"  id="opcMunicipal"> Secretaría de Hacienda </router-link>
            </li>
            <li class="opc">
                <router-link :to="{name: 'InventarioBienes'}" id="opcEstatal">Inventario de Bienes</router-link>
            </li>
            <li class="opc">
                <router-link :to="{name: 'CuentaPublicaFinanciera'}" id="opcFederal">Cta. Pública Financiera</router-link>
            </li>
            <li class="opc">
                <router-link :to="{name:'CuentaPublicaPresupuestal'}" id="opcPeriodico">Cta. Pública Presupuestal</router-link>
            </li>
            <li class="opc">
                <router-link :to="{name: 'InformacionContable'}" id="opcEstatal">Información Contable</router-link>
            </li>
            <li class="opc">
                <router-link :to="{name: 'InformacionPresupuestal'}" id="opcFederal">Información Presupuestal</router-link>
            </li>
            <li class="opc">
                <router-link :to="{name:'InformacionProgramatica'}" id="opcPeriodico">Información Programática</router-link>
            </li>
        </ul>
    </div>
    <div class="container"> <!-- contenedor_padre-->
        <!-- <boton-atras :nombre_ruta="'informesSHaciendaConac'"/> -->
        <div class="container mt-1 mb-1 text-right">
          <router-link to="/armonizacionContable/informesSHaciendaConac" class="btn btn-vino-o" style="border-radius:22px;"> <!--:to="{name:nombre_ruta}"-->
              <i class="fas fa-arrow-left"></i> Atrás
          </router-link>
        </div>
        <router-view></router-view>
    </div>



  </div>
</template>
<script>
import botonAtras from '@/views/button-atras.vue'
export default {
  components: { botonAtras },

}
</script>
<style scoped>
li>a{font-size: .8rem;}
.scroll-contenedor{
  width: auto;
  height: 45px;
  white-space: nowrap !important;


}
@media only screen and (max-device-width : 1024px){

  .scroll-contenedor{
  overflow-y: hidden;
  overflow-x: auto;
}

.scroll-contenedor::-webkit-scrollbar{
  height: 4px;
}
.scroll-contenedor::-webkit-scrollbar-thumb{
  background: #ededed;
}

}
</style>
